import React, { FC, useCallback, useEffect, useState } from 'react';

import { ResourcesLoader, TechnicalErrorPage } from 'omni-package-react-core';
import ConsentForm from './ConsentForm/ConsentForm';
import PersonalInformationResource from '../../components/PersonalInformationResource';
import Constants from '../../Constants';

export interface ConsentFormPageProps {
  getToken: () => Promise<string>;
}

const ConsentFormPage: FC<ConsentFormPageProps> = ({ getToken }) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [scriptError, setScriptError] = useState(false);

  const loadScript = useCallback(() => {
    const script: HTMLScriptElement = document.createElement('script');
    const link = document.createElement('link');
    script.src = `${process.env.REACT_APP_CONSENT_API_ROOT}/corpo/consentement/app/v2/permalink/js/main.js`;
    link.href = `${process.env.REACT_APP_CONSENT_API_ROOT}/corpo/consentement/app/v2/permalink/css/main.css" rel="stylesheet`;
    script.async = true;
    script.onload = () => {
      setScriptLoaded(true);
    };
    script.onerror = () => {
      setScriptError(true);
    };
    document.body.appendChild(script);
    document.body.appendChild(link);
  }, []);

  useEffect(() => {
    loadScript();
  }, [loadScript]);

  return (
    <>
      {scriptLoaded &&
        <ResourcesLoader>
          <ResourcesLoader.Resources>
            <PersonalInformationResource />
          </ResourcesLoader.Resources>
          <ResourcesLoader.Content>
            <ConsentForm getToken={getToken} />
          </ResourcesLoader.Content>
        </ResourcesLoader>}
      {scriptError && <TechnicalErrorPage redirectUrl={Constants.ProfilePath} />}

    </>
  );
};

export default (ConsentFormPage);
